<h5 class="side_filter_title">
  {{title}}
</h5>
<input type="text" class="form-control" [formControl]="searchControl" [placeholder]="searchPlaceholder"
  *ngIf="!hideSearch" />
<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>

<div *ngIf="!dataLoading">
  <div [formGroup]="form">
    @if (multiCheckbox) {
    <div class="check_group_filter" [formArrayName]="controlName">
      <ng-container *ngIf="formArray && formArray.controls && formArray.controls.length;else dataEmpty">
        <div *ngFor="let item of formArray.controls; let i = index" [formGroupName]="i" #recordItem>
          <input type="text" formControlName="id" hidden />
          <mat-checkbox formControlName="checked">
            {{ recordsData[i].name }}
          </mat-checkbox>
        </div>
      </ng-container>

    </div>
    }@else {
    <ng-container *ngIf="recordsData && recordsData.length;else dataEmpty">
      <mat-radio-group class="radio_group_filter" [formControlName]="controlName">
        <div *ngFor="let record of recordsData" (click)="toggleRadio($event, record.id)" #recordItem>
          <mat-radio-button [value]="record.id">
            {{ record.name }}
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </ng-container>
    }
  </div>
</div>
<div class="side_filter_more" *ngIf="pageNumber <= pageCount - 1 && !dataLoading">
  <button class="btn btn_link" type="button" (click)="getNextPage()" [class.loading]='loading'
    [disabled]='dataLoading || loading'>
    {{'general.showMore' | translate}}
  </button>
</div>

<ng-template #dataEmpty>
  <empty-state [custClass]="'p-0'" [title]="''" [img]="'assets/images/empty-data.png'"
    [desc]="emptyMessage|translate"></empty-state>
</ng-template>